import { EventIconAndTime } from "@components/StatsConsole/Widgets/OverviewWidget/parts/EventIconAndTime";
import { EventNameAndPlayerName } from "@components/StatsConsole/Widgets/OverviewWidget/parts/EventNameAndPlayerName";
import { formatEventTime } from "@utils/functions";
import { switchDescription } from "../functions";

interface IVAREventsHeightProps {
    event_type: string;
    player: string;
    team: string;
    time: string;
    height: string;
    description: string;
    isDescBold?: boolean;
    isPlusSignNeeded?: boolean;
}

export const VAREventsHeightAway = ({ player, team, time, event_type, height, description, isDescBold = false, isPlusSignNeeded = false }: IVAREventsHeightProps) => {
    const formattedTime = formatEventTime(time, isPlusSignNeeded);
    return (
        <div className={`flex justify-end mx-[16px] mb-[8px] min-h-[${height}px] max-h-[${height}px]`}>
            <EventNameAndPlayerName 
                ml="8px" 
                mr="8px" 
                startPosition='end' 
                event_type={event_type} 
                player={player} 
                isDescBold={isDescBold} 
                description={switchDescription(event_type, description)} 
            /> 
            <EventIconAndTime iconName={event_type} time={formattedTime} />
        </div>
    )
}